import axios from 'axios';
// initial state
// shape: [{ id, quantity }]
const state = () => ({
    addresses_id : [],
    addresses: [],
    company_id : 0,
    loaded : false,
    loading :false,
    addNew : false,
    columns : [
        {
            key : "addresstype",
            label : "addresstype",
        },
        {
            key : "name",
            label: "name",
        },
        {
            key : "street",
            label: "street",
        },
        {
            key : "postal_code",
            label : "postal_code",
        },
        {
            key : "town",
            label : "town",
        },
        {
            key : "country",
            label : "country",
            localized : true,
        },
        {
            key : "informations.mail",
            label : "mail",
        }
    ]
})

  // getters
  const getters = {
    getAddressOfType: (state) => (id) =>{
        return state.addresses.find(address => address.addresstype_id == id);
    },
  }

  // actions
  const actions = {
    async loadAdresses({commit, state, rootState}, company_id){
      if(company_id != undefined){
        commit("loading", true);
        commit("loaded", false);
        commit("setCompany", company_id);
        if(company_id == 0){
          commit("setAddresses", {});
        }else{
          await axios.get(rootState.settings.url + "/api/v1/"+rootState.settings.internal.user_company +"/companies/" + company_id + "/addresses").then((response) => {
            commit("setAddresses", response.data.data);
            commit("loaded", true);
          })
        }
        commit("loading", false);
        return state.addresses;
      }
    },
    async loadStockShippingAddress({commit, state, rootState}, kooiId){
        let shippingAddress = null;
        await axios.get(rootState.settings.url + "/api/v1/"+rootState.settings.internal.user_company +"/companies/stockShippingAddress/" + kooiId).then((response) => {
          if (response.data.data.length > 0) {
            commit("appendAddresses", response.data.data);
            shippingAddress = response.data.data[0];
          }else{
            commit("appendAddresses", []);
          }
        })

        return {
          addresses: state.addresses,
          shippingAddress: shippingAddress,
        };
      
    },    
    async delete({commit, state, rootState}, data){
        await axios.delete(rootState.settings.url + "/api/v1/" + rootState.settings.internal.user_company + "/companies/" + data.company_id + "/addresses/" + data.id).then(response => {
            commit("removeId", response.data.deleted);
        })
    }
  }

  // mutations
  const mutations = {
    clean(state){
      state.addresses = [];
      state.company_id = 0;
      state.loaded = false;
      state.loading = false;
      state.addNew = false;
    },
      setAddresses(state, addresses){
        state.addresses = addresses;
      },
      appendAddresses(state, addresses){
        state.addresses = [];
        for (const i in addresses) {
          state.addresses.push(addresses[i])
        }      
      },      
      setCompany(state, id){
        state.company_id = id;
      },
      loaded(state, status){
          state.loaded = status;
      },
      loading(state, status){
        state.loading = status;
      },
      removeId(state, id){
          var index = state.addresses.findIndex(item => item.id == id);
          if(index > -1){
              state.addresses.splice(index, 1);
          }

      }
  }

  export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
    modules: {
    }
  }
